<template>
  <DelDialog
    width="480px"
    :dialogVisible="editUserVisible"
    @handleClose="handleCancel"
    @handleConfirm="handleConfirm"
  >
    <template #title>编辑</template>
    <div class="edit-user">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
        <el-form-item prop="aliasName" :label="$t('managementV2.name')">
          <el-input v-model.trim="ruleForm.aliasName" :placeholder="$t('managementV2.pleaseinputName')"></el-input>
        </el-form-item>
        <el-form-item v-if="roleLevel !== 0" :label="$t('managementV2.role')" prop="roleId">
          <el-select v-model="ruleForm.roleId" :placeholder="$t('managementV2.pleaseselectRole')">
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="$i18n.locale === 'zh' ? item.name : $roleCase[item.roleType]"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
  </DelDialog>
</template>

<script>
import DelDialog from '@/components/delDialog';

import { editUsers } from "@/services/teamManagement";

export default {
  name: 'EditUser',
  props: {
    editUserVisible: {
      type: Boolean,
      default () {
        return false;
      }
    },
    roleList: {
      type: Array,
      default () {
        return [];
      }
    },
    editData: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  components: {
    DelDialog
  },
  data () {
    var username = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error(this.$t('project.nameTip')));
      } else if (value.length < 2) {
        callback(new Error(this.$t('managementV2.nameContainsMin')));
      } else if (value.length > 10) {
        callback(new Error(this.$t('managementV2.nameContainsMax')));
      }
      callback();
    };
    let roleId = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error(this.$t('managementV2.pleaseselectRole')));
      }
      callback();
    };
    return {
      ruleForm: {
        aliasName: '',
        roleId: '',
      },
      emailReg: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      phoneReg: /^(?:(?:\+|00)86)?1\d{10}$/,
      rules: {
        aliasName: [{ required: true, validator: username, trigger: "blur" }],
        roleId: [{ required: true, validator: roleId, trigger: "change" }],
      },
      roleLevel: 0,   // 超级管理员不能编辑自己的权限
      id: 0,
    }
  },
  methods: {
    async handleConfirm () {
      let flag = true;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          flag = false;
        }
      });
      if (flag) {
        return;
      }
      // 如果是超级管理员，roleLevel不变，超级管理员的roleLevel为0
      let roleLevel = this.roleLevel === 0 ? this.roleLevel : this.roleList.find(item => this.ruleForm.roleId === item.id).roleLevel;
      const { success } = await editUsers({
        id: this.id,
        ...this.ruleForm,
        roleLevel
      });
      if (success) {
        this.$message.success(this.$t("managementV2.userSuccessed"));
        this.$emit('updateTeamList');
        this.handleCancel();
      }
    },
    handleCancel () {
      this.$refs.ruleForm.clearValidate();
      this.$emit('handleCancel');
    },
  },
  watch: {
    editData: {
      handler (newVal) {
        this.roleLevel = newVal.roleLevel;
        this.ruleForm.roleId = newVal.roleId;
        this.ruleForm.aliasName = newVal.aliasName;
        this.id = newVal.id;
      },
      deep: true,
    }
  }
}
</script>

<style lang="less" scoped>
  @import "./assets/style.less";
</style>